import { render, staticRenderFns } from "./EditCPage.vue?vue&type=template&id=734c823c&"
import script from "./EditCPage.vue?vue&type=script&lang=js&"
export * from "./EditCPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports